
const data = [
    {
      title : "GUESS THE NUMBER",
      icon : <i class="fa-solid fa-plus-minus" />,
      link : "https://anshumxn09.github.io/GuessTheNumber/"
    }, 
    {
      title : "TIC TAC TOE",
      icon : <i class="fa-solid fa-xmarks-lines"></i>,
      link : "https://anshumxn09.github.io/TicTacToe.github.io/"
    },
    {
      title : "MUSIC ALBUM",
      icon : <i class="fa-solid fa-play"></i>,
      link : " https://anshumxn09.github.io/MyDearMelancholy.github.io/"
    },
    {
      title : "QUIZ APP",
      icon : <i class="fa-solid fa-ranking-star"></i>,
      link : "https://anshumxn09.github.io/QuizApp.github.io/"
    },
    {
      title : "TWEET QUOTES",
      icon : <i class="fa-solid fa-hashtag"></i>,
      link : "https://anshumxn09.github.io/dynamicQuotes.github.io/"
    },
    {
      title : "TO-DO",
      icon : <i class="fa-solid fa-list"></i>,
      link : "https://setgoalstowin.netlify.app/",
    },
    {
      title : "TEXT TO SPEECH",
      icon : <i class="fa-solid fa-volume-high"></i>,
      link : "https://text2speeech.netlify.app/"
    },
    {
      title : "FIND PALINDROME",
      icon : <i class="fa-solid fa-magnifying-glass"></i>,
      link : "https://findpalindrome.netlify.app/"
    },
    {
      title : "CLICK TO KNOW",
      icon : <i class="fa-solid fa-wand-magic-sparkles"></i>,
      link : "https://anshumxnportfolio.netlify.app/"
    },
  ]

export default data;